exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss"), undefined);

// module
exports.push([module.id, ".Kit__thingImage___2iiSF {\n\tborder-radius: 50%;\n\tbox-shadow: 0px 1px 5px 1px rgba(33,33,33,0.1);\n}\n\n.Kit__loading___3JXrT {\n\theight: 1.5rem;\n    margin-right: 1.5rem;\n    color: " + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["mainPanelBackgroundColour"] + "!important;\n}\n\n.Kit__loadingSurround___pvzYK {\n\tdisplay: flex;\n\tmargin: 1rem 0 0 1rem;\n\talign-items: center;\n}\n\n.Kit__noPosts___2yuKq {\n\tpadding: " + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + ";\n}\n", ""]);

// exports
exports.locals = {
	"pagePadding": "" + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["pagePadding"] + "",
	"mainPanelBackgroundColour": "" + require("-!../../../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!../../colours.icss").locals["mainPanelBackgroundColour"] + "",
	"thingImage": "Kit__thingImage___2iiSF",
	"loading": "Kit__loading___3JXrT",
	"loadingSurround": "Kit__loadingSurround___pvzYK",
	"noPosts": "Kit__noPosts___2yuKq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/User/Kit.icss
// module id = 1588
// module chunks = 0